import api from "./api";

export interface PaymentMethod {
  id: number;
  code: string;
  name: string;
  description?: string;
  status: boolean;
}

const paymentMethodService = {
  getPaymentMethods: async (): Promise<PaymentMethod[]> => {
    const response = await api.get("/payment-methods");
    return response.data?.data ?? response.data ?? [];
  },
};

export default paymentMethodService;
